<div class="logout-container">
  <div class="logout-box">
    <h1>You have been logged out</h1>
    <p>Thank you for visiting. You have successfully logged out of your account.</p>
    <button (click)="onLoginRedirect()">Login Again</button>
  </div>
</div>
